import React from 'react';
import { FormattedMessage } from 'react-intl';

import { OptionFormTypes as FormOptionTypes } from '../../../../../../services/filtering/filter-form-render-service/option-form-types';
import { renderFormBasedOnType } from '../../../../../../services/filtering/filter-form-render-service/';
import messages from './messages';

export const STORE_GUIDS = 'storeGuids';

type Store = {
  storeGuid: string;
  name: string;
};

type AppliedFilter = {
  filterById: string;
  criterionArgumentValue: string;
};

export const buildStoreFilter = (stores: Store[]) => ({
  id: STORE_GUIDS,
  type: FormOptionTypes.TYPE_CHECKLIST,
  filterValue: STORE_GUIDS,
  allowsMultipleSelection: true,
  shouldHideActionButtons: true,
  displayName: (appliedFilters: AppliedFilter[]) => {
    const storeFilters = appliedFilters.filter((filter) => filter.filterById === STORE_GUIDS);
    if (storeFilters.length === 0) {
      return <FormattedMessage {...messages.store} />;
    }
    if (storeFilters.length === 1) {
      const selectedGuid = storeFilters[0].criterionArgumentValue;
      const store = stores.find((s) => s.storeGuid === selectedGuid);
      return store?.name ?? <FormattedMessage {...messages.store} />;
    }
    return <FormattedMessage {...messages.multipleStores} />;
  },
  // oxlint-disable-next-line @typescript-eslint/no-explicit-any
  render: (criteriaInformations: any, existingFiltersHelpers: any) => {
    return renderFormBasedOnType(FormOptionTypes.TYPE_CHECKLIST, criteriaInformations, existingFiltersHelpers);
  },
});
